import { FC, Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { useAuth } from 'contexts';
import PATHS, { pathsInterface } from './paths';
import NotFoundPage from 'pages/NotFound';

const ProtectedRoute: FC<any> = ({ redirectPath = '/login', children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default function RoutesLayout() {
  const routeTree = (objRoute: pathsInterface[]) =>
    objRoute.map(route => (
      <Route key={route.id} path={route.pathname} element={route.private ? <ProtectedRoute /> : <Outlet />}>
        <Route index element={route.component} />
        {route.children?.length ? routeTree(route.children) : null}
      </Route>
    ));

  return (
    <>
      <Routes>
        {!!PATHS.length && routeTree(PATHS)}

        <Route
          path="*"
          element={
            <Suspense fallback={<div />}>
              <NotFoundPage />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
}
